import { render, staticRenderFns } from "./NoticeContents.vue?vue&type=template&id=5efad12b&scoped=true"
import script from "./NoticeContents.vue?vue&type=script&lang=js"
export * from "./NoticeContents.vue?vue&type=script&lang=js"
import style0 from "./NoticeContents.vue?vue&type=style&index=0&id=5efad12b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efad12b",
  null
  
)

export default component.exports